export default {
  title: 'RSVP POOL SETTINGS',
  items: {
    SharedP2P: {
      label: 'SharedP2P',
      type: 'boolean'
    },
    SharedToAirport: {
      label: 'SharedToAirport',
      type: 'boolean'
    },
    SharedFromAirport: {
      label: 'SharedFromAirport',
      type: 'boolean'
    },
    OpoliP2P: {
      label: 'OpoliP2P',
      type: 'boolean'
    },
    OpoliToAirport: {
      label: 'OpoliToAirport',
      type: 'boolean'
    },
    OpoliFromAirport: {
      label: 'OpoliFromAirport',
      type: 'boolean'
    },
    BlackP2P: {
      label: 'BlackP2P',
      type: 'boolean'
    },
    BlackToAirport: {
      label: 'BlackToAirport',
      type: 'boolean'
    },
    BlackFromAirport: {
      label: 'BlackFromAirport',
      type: 'boolean'
    },
    SUVP2P: {
      label: 'SUVP2P',
      type: 'boolean'
    },
    SUVToAirport: {
      label: 'SUVToAirport',
      type: 'boolean'
    },
    SUVFromAirport: {
      label: 'SUVFromAirport',
      type: 'boolean'
    },
    PrivateShuttleP2P: {
      label: 'PrivateShuttleP2P',
      type: 'boolean'
    },
    PrivateShuttleToAirport: {
      label: 'PrivateShuttleToAirport',
      type: 'boolean'
    },
    PrivateShuttleFromAirport: {
      label: 'PrivateShuttleFromAirport',
      type: 'boolean'
    },
    MaxDailyRSVP: {
      label: 'Max Daily RSVP',
      type: 'integer',
      unit: '1-999'
    },
    TimeRangeRSVP: {
      label: 'Time Range',
      type: 'integer',
      unit: 'minutes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/rsvp-pool-settings.js